"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Icons = exports.Icon = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  hideOnDesktop,
  theme
}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    display: hideOnDesktop ? 'none' : 'flex'
  }
}));
const Icons = exports.Icons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(4)
}));
const Icon = exports.Icon = (0, _mui.styled)('div')(() => ({
  display: 'inline-block',
  width: 35,
  height: 35,
  overflow: 'hidden'
}));
